import type { OAISchema } from '~/types/openapi';

type ConstantValue = {
  text: string;
  value: string;
};

export const DELIVERY_TYPES: Record<
  NonNullable<OAISchema['MarketDeliveryPolicyResponse']['deliveryType']>,
  ConstantValue
> = {
  NONE: {
    text: '미지정',
    value: 'NONE',
  },
  COURIER: {
    text: '택배배송',
    value: 'COURIER',
  },
  SELF: {
    text: '직배송',
    value: 'SELF',
  },
  E_COUPON: {
    text: 'E_COUPON',
    value: 'E_COUPON',
  },
  INTANGIBLE_INSTANT: {
    text: '',
    value: 'INTANGIBLE_INSTANT',
  },
  INTANGIBLE_WITH_STATUS: {
    text: '',
    value: 'INTANGIBLE_WITH_STATUS',
  },
};

export const DELIVERABLE_DAYS = {
  1: {
    text: '월',
    value: 1,
  },
  2: {
    text: '화',
    value: 2,
  },
  3: {
    text: '수',
    value: 3,
  },
  4: {
    text: '목',
    value: 4,
  },
  5: {
    text: '금',
    value: 5,
  },
  6: {
    text: '토',
    value: 6,
  },
  7: {
    text: '일',
    value: 7,
  },
};

export const RETURN_EXCHANGE_POLICY_PICKUP_METHODS: Record<
  NonNullable<OAISchema['MarketReturnExchangePolicyResponse']['pickUpMethod']>,
  ConstantValue
> = {
  NONE: {
    text: '미지정',
    value: 'NONE',
  },
  COURIER: {
    text: '택배배송',
    value: 'COURIER',
  },
  SELF: {
    text: '직배송',
    value: 'SELF',
  },
  E_COUPON: {
    text: 'E_COUPON',
    value: 'E_COUPON',
  },
};

export const DELIVERY_ATTENTION_GUIDE = {
  INSIDE_STORE: {
    placeholder: `비밀번호/열쇠 위치를 입력해주세요.`,
    attentionText: `정확한 출입정보를 작성하지 않으면 주문이 취소되거나 가게 안 배송이 불가할 수 있습니다.`,
  },
  REFRIGERATOR: {
    placeholder: `비밀번호/열쇠 위치를 입력해주세요.\n냉장고 공간이 충분하지 않으면 냉장고 안 배송이 어려울 수 있습니다.`,
    attentionText: `냉장고 공간이 충분하지 않으면 냉장고 안 배송이 어려울 수 있습니다.`,
  },
  CUSTOM: {
    placeholder: `비밀번호/열쇠 위치를 입력해주세요.\n봄 여름에는 기온이 높아 상품이 변질될 수 있어요.\n상온 배송의 상품 변질문제는 책임지지 않습니다.\n가급적 냉장고 안 배송을 이용해주세요.`,
    attentionText: `일부 판매자의 경우 출입정보를 작성하지 않으면 주문이 취소될 수 있습니다.`,
  },
};

export const SAFE_DELIVERY_TYPE = {
  NONE: {
    text: '',
  },
  INSIDE_STORE: {
    text: '가게 안',
  },
  REFRIGERATOR: {
    text: '냉장고',
  },
  CUSTOM: {
    text: '직접 입력',
  },
};
